const OrderList = () => import('./components/OrderList.vue')
const OrderDetail = () => import('./components/OrderDetail.vue')
const PrintingSpool = () => import('./components/PrintingSpool.vue')

export default [
    {
        path: 'edge-prints',
        redirect: 'edge-prints/orders',
        name: 'edgePrints',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        meta: {
            label: 'Printers',
            title: 'Printers',
            breadcrumb: {
                text: 'Printers',
                to: { name: 'edgePrintOrderList' }
            }
        },
        children: [
            {
                path: 'orders',
                name: 'edgePrintOrderList',
                component: OrderList,
                meta: {
                    label: 'Print Orders',
                    title: 'Print Orders',
                    perms: ['event_wizard.see_printer']
                },
            },
            {
                path: 'orders/:orderId([0-9]+)',
                name: 'edgePrintOrderDetail',
                component: OrderDetail,
                meta: {
                    label: 'Order detail',
                    breadcrumb: (context) => {
                        const order = context.store.getters['edgePrints/currentOrder']
                        return {
                            text: order ? `Order #${order.transaction_number}` : `Order`
                        }
                    },
                    perms: ['event_wizard.see_printer']
                },
            },
            {
                path: 'jobs',
                name: 'edgePrintJobList',
                component: PrintingSpool,
                meta: {
                    label: 'Print Jobs',
                    title: 'Print Jobs',
                    perms: ['event_wizard.see_printer']
                },
            },
        ]
    },
]